import requset from "utils/request";
import { WRITE, BENDI, CDNBOOK } from "apiurl/index.js";
// 书籍详情
//=====cdn
export function BookDetail(bookId) {
  return requset({
    url: `${CDNBOOK}/cdn/pc/${bookId}`,
    method: "GET"
  });
}
// 书籍目录
export function Bookmenu(params) {
  return requset({
    url: `${CDNBOOK}/cdn/menu`,
    method: "GET",
    params
  });
}
// 书籍内容
// ==========免费章节接口cdn
export function chapterCon(params) {
  return requset({
    url: `${CDNBOOK}/cdn/pc/chapter`,
    method: "GET",
    params
  });
}

/* 收费 */
export function chapternoCon(params) {
  return requset({
    url: `${WRITE}/cdn/pc/chapter`,
    method: "GET",
    params
  });
}
/* 添加阅读记录 */
export function addreadhistory(params) {
  return requset({
    url: `${BENDI}/read/record/add`,
    method: "POST",
    params
  });
}
// 阅读历史
export function readhistory(params) {
  return requset({
    url: `${BENDI}/read/record/list`,
    method: "GET",
    params
  });
}
export function lasthistory(params) {
  return requset({
    url: `${BENDI}/read/record/last`,
    method: "GET",
    params
  });
}
// 移除阅读
export function deletehistory(params) {
  return requset({
    url: `${BENDI}/read/record/del`,
    method: "POST",
    params
  });
}
// 加入书架
export function addshelf(params) {
  return requset({
    url: `${BENDI}/user/shelf/add`,
    method: "POST",
    params
  });
}
// 获取书架列表
export function getshelf(params) {
  return requset({
    url: `${BENDI}/user/shelf/list`,
    method: "GET",
    params
  });
}
// 获取最近最新加入的书
export function getNewBook() {
  return requset({
    url: `${BENDI}/user/shelf`,
    method: "GET"
  });
}
// 移除书架
export function deleteshelf(params) {
  return requset({
    url: `${BENDI}/user/shelf/del`,
    method: "POST",
    params
  });
}
/* 首页书架 */
export function getBookList(params) {
  return requset({
    url: `${CDNBOOK}/core/pc/open/book/list`,
    method: "GET",
    params
  });
}
/* 获取某本书的阅读状态---个人--非cdn */
export function readstatus(params) {
  return requset({
    url: `${BENDI}/read/record/status`,
    method: "GET",
    params
  });
}
/* 购买章节 */

export function buyChapter(params) {
  return requset({
    url: `${WRITE}/core/pc/chapter/buy`,
    method: "POST",
    params
  });
}
/* 获取章节浏览数 */
export function chapterVisitor(params) {
  return requset({
    url: `${WRITE}/core/pc/chapter/visitor`,
    method: "POST",
    params
  });
}
/* 是否开启自动订阅 */
export function buyAuto(params) {
  return requset({
    url: `${BENDI}/read/record/autoSubScribe`,
    method: "POST",
    params
  });
}

/* shelf */
export function homeshelf(params) {
  return requset({
    url: `${CDNBOOK}/cdn/home`,
    method: "GET",
    params
  });
}
export function moreshelf(params) {
  return requset({
    url: `${CDNBOOK}/cdn/shelf`,
    method: "GET",
    params
  });
}
/* 获取发布作品信息 */
export function bookInfo(params) {
    return requset({
      url: `${CDNBOOK}/cdn/book/info`,
      method: "GET",
      params
    });
  }
  export function getOpenStatus(bookid) {
    return requset({
      url: `${WRITE}/book/open/status/${bookid}`,
      method: "GET"
    });
  }
